import type { RouteRecordRaw } from 'vue-router'

export const VideoRouter: RouteRecordRaw[] = [
  {
    path: '/video',
    component: async () => import('./video.vue'),
  },
]
